import React, {Fragment} from "react";
import Modal from "../../layout/Modal";
import Portal from "../../layout/Portal";
import Button from "../Button";
import DocumentInput from "../DocumentInput";
import Icon from "../Icon";
import PrintButton from "../PrintButton";
import classNames from "classnames";
import {sendRequest} from "../../../utils/request";
import {get} from "../../../utils/dotutils";

class DocumentButton extends React.Component {

    state = {};

    remove = async () => {
        if (!this.state.remove) {
            this.setState({remove: true});
            return;
        }
        await this.props.selectorgrid.onItemRemove(this.props.row);
        this.setState({remove: false});
    }

    render() {
        return (
            <div className="document-button">
                {
                    this.props.name &&
                    <Fragment>
                        <Portal>
                            <Modal
                                state={this.state.remove}
                                theme="default"
                                header="Törlés"
                                buttons={[
                                    {
                                        text: "Mégse",
                                        props: {color: "default", disabled: this.props.disabled || this.props.isLoading || this.state.isLoading},
                                        onClose: true,
                                        onClick: async () => {
                                            try {
                                                this.setState({remove: false});
                                            } catch (e) {

                                            }
                                        }
                                    },
                                    {
                                        text: "Törlés",
                                        props: {color: "danger", disabled: this.props.disabled || this.props.isLoading || this.state.isLoading},
                                        onClick: async () => {
                                            try {
                                                await this.remove();
                                            } catch (e) {

                                            }
                                        }
                                    }
                                ]}
                            >
                                Biztosan törlöd ezt a tételt?
                            </Modal>
                        </Portal>
                        <Button
                            color="danger"
                            icon={{lib: "fa", name:"times"}}
                            onClick={() => {this.remove()}}
                            className="remove-button"
                            size="xs"
                        />
                    </Fragment>
                }
                <PrintButton
                    url={this.props.row.path + this.props.row.filename}
                    color={"default"}
                    icon={{lib: "fa", name: "print"}}
                    className={"pull-left"}
                    disabled={this.props.disabled}
                >
                    {this.props.row.filename}
                    {get(this.props, "row.type.optionlabel") ? <b> ({get(this.props, "row.type.optionlabel")})</b> : null}
                </PrintButton>
            </div>
        )
    }

}

let documentTypes = null;

class SelectorDocuments extends React.Component {

    state = {
        documentType: 1,
        opened: false
    }

    constructor(props) {
        super(props);

        this.wrapperRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    getDocumentTypes = () => {
        const optionName = 'DocumentType';
        this.optionRequest && this.optionRequest.abort();
        this.optionRequest = sendRequest({
            option: "componentlist",
            component: "option",
            itemsperpage: 0,
            //filter: [{filters: [{field: "xtradata", value: this.props.component},{field: "xtradata", operator: "isnull"}], operator: "OR"}],
            optionname: optionName
        }).then((data) => {
            const items = {};
            ((data || {}).items || []).map((option) => {
                items[option.optionid] = option
            });
            documentTypes = {...items};
            this.forceUpdate();
        });
    }

    componentDidMount() {
        this.getDocumentTypes();
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    /**
     * Alert if clicked on outside of element
     */
    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
            this.setState({
                opened: false
            });
        }
    }

    render() {
        let {value, emptyMessage, disabled, loading, name, listfield, label, componentConfig} = this.props;
        const parentid = (this.props.data && this.props.data[this.props.componentConfig.idfield]) || this.props.parentid;
        return (
            <div className="selector-grid documents">
                {
                    value.length ?
                        value.map((row, idx) => {
                            return (
                                <DocumentButton
                                    key={idx}
                                    row={row}
                                    disabled={disabled || loading}
                                    selectorgrid={this.props.selectorgrid}
                                    name={name}
                                    listfield={listfield}
                                />
                            )
                        })
                        :
                        <div className="pull-left">{emptyMessage}</div>
                }
                {
                    name && !loading &&
                    <div className="p-splitbutton p-buttonset p-component p-button-primary" ref={this.wrapperRef}>
                        <DocumentInput
                            label={false}
                            name={name}
                            componentConfig={this.props.componentConfig}
                            values={{[this.props.componentConfig.idfield]: parentid}}
                            {...this.props}
                            documentType={this.state.documentType}
                            saveChanges={() => this.props.selectorgrid.refresh()}
                            uploadAction={this.props.onAddRows && ((acceptedFiles) => this.props.onAddRows(acceptedFiles, this.state.documentType))}
                            className="add-document"
                        >
                            <span className="p-button p-component p-button-text-icon-left">
                                <Icon lib="fa" name="plus" /> {((documentTypes || {})[this.state.documentType] || {}).optionlabel}
                            </span>
                        </DocumentInput>
                        <div className="p-button p-component p-splitbutton-menubutton p-button-icon-only" onClick={() => this.setState({opened: !this.state.opened})}>
                            <span className="pi pi-caret-down p-c p-button-icon-left" />
                            <span className="p-button-text p-c">p-btn</span>
                        </div>
                        <div className={classNames("p-menu p-menu-dynamic p-menu-overlay p-component", {"p-menu-overlay-visible": this.state.opened})}>
                            <ul className="p-menu-list p-reset">
                                {
                                    Object.keys(documentTypes || {}).map((optionid, idx) => {
                                        return <li key={idx} className="p-menuitem" role="menuitem">
                                            <a href="#" className="p-menuitem-link" onClick={(e) => {
                                                e.preventDefault();
                                                this.setState({
                                                    documentType: optionid,
                                                    opened: false
                                                });
                                            }}>
                                                <span className="p-menuitem-text"><span> {((documentTypes || {})[optionid] || {}).optionlabel}</span></span>
                                            </a>
                                        </li>;
                                    })
                                }
                            </ul>
                        </div>
                    </div>
                }
                <div className="clearfix"/>
            </div>
        )
    }
}

export default SelectorDocuments;